import * as React from 'react';
import { Dispatch, SetStateAction, useMemo } from 'react';
import VoxelAutocomplete, {
  GenericOption,
} from '../../../../components/voxel/Forms/VoxelAutocomplete';
import { TagGroupGq } from '../../../../graphql/projects/models/TagGroupGq';
import { AnalysisFilterState } from '../../Filter/analysisFilterState';

export interface SingleTagAutocompleteProps {
  tagGroup: TagGroupGq;
  analysisFilterState: AnalysisFilterState;
  setAnalysisFilterState: Dispatch<SetStateAction<AnalysisFilterState>>;
}

const SingleTagAutocomplete: React.FC<SingleTagAutocompleteProps> = ({
  tagGroup,
  analysisFilterState,
  setAnalysisFilterState,
}) => {
  // Styling

  const options: GenericOption[] = [
    { value: -1, title: 'none' },
    ...(tagGroup?.tags.map((t) => ({ value: t.id, title: t.name })) ?? []),
  ];
  const selectedOptionValues = useMemo(
    () => (analysisFilterState?.tagId ? [analysisFilterState?.tagId] : [-1]),
    [analysisFilterState?.tagId]
  );
  return (
    <VoxelAutocomplete
      size="sm"
      label="Tag filter"
      labelPosition='left'
      emptyAllowed={false}
      options={options}
      setSelectedOptions={(options: GenericOption[] | null) => {
        setAnalysisFilterState((prev) => ({ ...prev, tagId: options[0].value }));
      }}
      selectedOptionValues={selectedOptionValues}
      inputWidthClass='w-64'
    />
  );
};

export default SingleTagAutocomplete;
